export enum EmployeeSex {
  Male = "M",
  Female = "F",
}
